<template>
    <div v-if="enabled" class="tooltip">
        <slot />
    </div>
</template>

<script>
    export default {
        props: {
            enabled: {
                type: Boolean,
                default: true,
                required: false
            }
        }
    }
</script>

<style lang="scss">
    @use 'sass:math';
    @import '../styles/base';
    @import '../../node_modules/hd-styles/base';
    @import '../../node_modules/hd-styles/modules/mixins';

    .tooltip {
        @include tooltip(bottom, 10px, $grey-dark, $border-width: 0);
        @include rem(font-size, $epsilon-font-size);

        background-color: $grey-dark;
        color: $white;
        width: 100%;
        white-space: normal;
        padding: math.div($spacing-unit, 2);
        border-radius: $border-radius;
        margin-top: $spacing-unit;
    }
</style>
